import { UsersThree } from '@phosphor-icons/react';

export default UsersThree;
